import { observable, runInAction } from "mobx"

import { Ellipsis } from "@/components/Ellipsis/Ellipsis.ts"
import { Model } from "@/lib/Model.ts"

type LinariaMeta = {
  className: string
}

export class TooltipModel extends Model {
  readonly hasTooltip = observable.box(false)
  private resizeObserver: ResizeObserver | null = null

  constructor(private readonly ignoreEllipsis: boolean = false) {
    super("TooltipModel")
  }

  readonly setupObserver = (element: HTMLElement | null) => {
    this.cleanupObserver()

    if (element) {
      this.resizeObserver = new ResizeObserver((entries) => {
        const el = entries.length && entries[0].target as HTMLElement

        if (el) {
          if (!this.ignoreEllipsis && el.classList.contains((Ellipsis.__wyw_meta as LinariaMeta).className)) {
            // Only show the tooltip if ellipsis is visible
            runInAction(() => {
              this.hasTooltip.set(el.offsetWidth < el.scrollWidth)
            })
          } else {
            runInAction(() => {
              this.hasTooltip.set(true)
            })
          }
        }
      })

      this.resizeObserver.observe(element)
    }
  }

  private readonly cleanupObserver = () => {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  }

  terminate() {
    this.cleanupObserver()
    super.terminate()
  }
}